import { createGlobalStyle } from 'styled-components';
import { colorText } from '@spark/ui-components/theme';
import { left, right } from '@spark/ui-components/theme';
const NotificationStyles = createGlobalStyle`
  .rc-notification {
    position: fixed;
    z-index: 1050;
    pointer-events: none;
  }
  
  .rc-notification-notice {
    display: block;
    width: auto;
    line-height: 1.5;
    vertical-align: middle;
    position: relative;
    pointer-events: auto;
  }
  
  .rc-notification-notice-close {
    position: absolute;
    cursor: pointer;
    outline: none;
    font-weight: 700;
    line-height: 1;
    opacity: .2;
    text-decoration: none;
  }
  
  .rc-notification-notice-close-x:after {
    content: '×';
  }
  
  .rc-notification-fade-enter {
    opacity: 0;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
    animation-play-state: paused;
  }
  
  .rc-notification-fade-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
    animation-play-state: paused;
  }
  
  .rc-notification-fade-enter.rc-notification-fade-enter-active {
    animation-name: rcNotificationFadeIn;
    animation-play-state: running;
  
    &.right-up {
      animation-name: rcNotificationRightFadeIn;
    }
  
    &.left-up {
      animation-name: rcNotificationLeftFadeIn;
    }
  }
  
  .rc-notification-fade-leave.rc-notification-fade-leave-active {
    animation-name: rcDialogFadeOut;
    animation-play-state: running;
  }
  
  @keyframes rcNotificationFadeIn {
    0% {
      transform: translateY(-100%);
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes rcNotificationLeftFadeIn {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes rcNotificationRightFadeIn {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes rcDialogFadeOut {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
  
  .rc-notification {
    ${left}: auto !important;
    top: 60px !important;
    height: auto;
    pointer-events: none;
  
    & > span {
      height: auto;
      display: block;
      pointer-events: none;
    }
  }
  
  .rc-notification-notice-close {
    position: absolute;
    ${right}: 18px;
    top: 8px;
    font-size: 18px;
    line-height: 1;
    font-weight: 400;
    color: ${colorText};
    text-shadow: none;
    opacity: 0.4;
    pointer-events: auto;
    z-index: 2;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    cursor: pointer;
  
    &:hover {
      opacity: 0.8;
      color: ${colorText};
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
`;
export default NotificationStyles;
